import React from 'react';
import { InstagramIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { LogoPlaceholder } from './Placeholders';
export function Footer() {
  return <footer id="contacto" className="bg-negro pt-12 md:pt-20 pb-10 px-6 md:px-12" data-id="element-9">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-10">
        <LogoPlaceholder className="w-44 h-44 md:w-64 md:h-64 mb-8 md:mb-12" data-id="element-11" />

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 font-labrada text-crema text-base md:text-lg mb-10 md:mb-16" data-id="element-12">
          <a href="https://instagram.com/lloqe.textiles" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 hover:text-marron transition-colors" data-id="element-13">
            <span className="flex items-center justify-center w-9 h-9 rounded-full border border-crema/25" data-id="element-14">
              <InstagramIcon className="w-4 h-4" data-id="element-15" />
            </span>
            <span data-id="element-16">@lloqe.textiles</span>
          </a>

          <a href="mailto:lloque.textiles@gmail.com" className="flex items-center gap-2.5 hover:text-marron transition-colors" data-id="element-17">
            <span className="flex items-center justify-center w-9 h-9 rounded-full border border-crema/25" data-id="element-18">
              <MailIcon className="w-4 h-4" data-id="element-19" />
            </span>
            <span data-id="element-20">lloque.textiles@gmail.com</span>
          </a>

          <a href="https://www.google.com/maps/place/Lloq'e/@-23.7467624,-65.4995295,21z" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 hover:text-marron transition-colors" data-id="element-21">
            <span className="flex items-center justify-center w-9 h-9 rounded-full border border-crema/25" data-id="element-22">
              <MapPinIcon className="w-4 h-4" data-id="element-23" />
            </span>
            <span data-id="element-24">Esq. Lavalle y Belgrano, Purmamarca, Jujuy</span>
          </a>
        </div>

        <p className="font-labrada font-bold text-crema text-2xl md:text-3xl mb-10 md:mb-16" data-id="element-25">
          Tejidos que protegen — Quebrada de Humahuaca
        </p>

        <div className="w-full border-t border-marron pt-8" data-id="element-26">
          <p className="font-labrada font-thin text-crema/70 text-sm" data-id="element-27">
            © 2025 Lloq'e Textiles Ancestrales
          </p>
        </div>
      </div>
    </footer>;
}